import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1, ease: EASE } },
};

export const MaskTitle = ({ lines, className = "", lineClassName = "" }) => (
  <motion.h2
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.1 }}
    transition={{ staggerChildren: 0.09 }}
  >
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.04em]">
        <motion.span variants={lineVariants} className={`block ${typeof l === "object" && l.className ? l.className : lineClassName}`}>
          {typeof l === "object" ? l.text : l}
        </motion.span>
      </span>
    ))}
  </motion.h2>
);

export const SectionLabel = ({ index, children, dark = true }) => (
  <div className={`label-mono flex items-center gap-3 ${dark ? "text-white" : "text-zinc-700"}`}>
    <span className={dark ? "text-volt" : "text-ink font-bold"}>{index}</span>
    <span className={`h-px w-10 ${dark ? "bg-white/20" : "bg-ink/30"}`} />
    <span>{children}</span>
  </div>
);

export const SampleBadge = ({ show, dark = true }) => {
  const { t } = useLang();
  return show ? (
    <span
      data-testid="sample-data-badge"
      className={`label-mono inline-flex items-center gap-2 border px-3 py-1 text-[11px] ${dark ? "border-volt/40 text-volt" : "border-ink/30 text-ink"}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current blink" /> {t.sample}
    </span>
  ) : null;
};
